import React, { useState } from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Collapse
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';

export const seoMeta = {
  title: 'Пликове за детски завивки памучен сатен 100% памук | Размери по поръчка | GoToBed',
  description:
    'Пликове за детски завивки от памучен сатен 100% памук. Гладка и мека материя, размери 105/140, 140/200, 150/210. Изработка по поръчка. Поръчайте от GoToBed.'
};

const seoLinkStyle = {
  color: '#F57819',
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': { color: '#A34D08' }
};

export function SeoHeader() {
  const [introExpanded, setIntroExpanded] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        component="h1"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: 0
        }}>
        Пликове за детски завивки от памучен сатен
      </Typography>
      <Typography variant="h6" component="p" fontWeight={600} sx={{ mb: 2 }}>
        Пликове за детски завивки от памучен сатен
      </Typography>
      <Box
        sx={{
          ...(!introExpanded && {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          })
        }}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Пликовете за детски завивки от памучен сатен са изработени от 100% памук и се отличават с
          гладка и мека повърхност. Фината и дишаща материя е подходяща за чувствителната детска
          кожа. Пликовете се изработват по поръчка и се предлагат в едноцветни и шарени (с принт)
          десени, както и в голямо разнообразие от размери като 105/140, 115/150, 140/200 и 150/210.
        </Typography>
      </Box>
      <Button
        onClick={() => setIntroExpanded(!introExpanded)}
        size="small"
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          p: 0,
          minWidth: 0,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
        }}>
        {introExpanded ? 'Скрий' : 'Прочетете повече'}
      </Button>
    </Box>
  );
}

export default function SeoBody() {
  return <SeoBodyDetskiPlikoveSaten />;
}

function SeoBodyDetskiPlikoveSaten() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ mt: 6 }}>
      {/* H2: Пликове за детски завивки от памучен сатен – 100% памук */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
        Пликове за детски завивки от памучен сатен – 100% памук
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Пликът за детска завивка от памучен сатен е отличен избор за родители, които търсят мека,
        гладка и приятна на допир памучна материя за детско спално бельо. Памучният сатен е
        висококачествен 100% памучен плат, който се отличава с фин допир, гладка структура и лек
        естествен блясък.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        В тази категория ще откриете детски пликове за завивки от памучен сатен, подходящи както за
        бебешки завивки, така и за по-големи детски одеяла. Материята е дишаща, приятна на допир и
        осигурява комфортен и спокоен сън за детето.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Памучният сатен е особено подходящ за родители, които търсят по-фина и гладка памучна тъкан,
        която съчетава мекота, дишаемост и комфорт при сън.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Всички пликове се изработват внимателно в България от платове със сертификат OEKO-TEX
        Standard 100, който гарантира, че текстилът не съдържа вредни вещества и е безопасен за
        бебешката и детската кожа.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        За да създадете комплект детско спално бельо от същата материя, можете да комбинирате плика
        с
      </Typography>
      <Box sx={{ mb: 4, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/detsko-spalno-belio/detski-charshafi/2/7/1"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          детски чаршафи памучен сатен
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/detsko-spalno-belio/detski-charshafi-s-lastik/2/9/1"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          детски чаршафи с ластик памучен сатен
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/detsko-spalno-belio/detski-kalufki/2/8/1"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          детски калъфки памучен сатен
        </Typography>
      </Box>

      <Collapse in={expanded} collapsedSize={0}>
        {/* H2: Размери пликове за детски завивки от памучен сатен */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Размери пликове за детски завивки от памучен сатен
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Едно от основните предимства на нашите продукти е голямото разнообразие от размери, което
          позволява лесно да намерите подходящ детски плик памучен сатен за различни размери
          завивки.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Предлагаме пликове за детски завивки със следните размери:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            '103/130',
            '105/140',
            '115/150',
            '115/160',
            '130/200',
            '140/200',
            '140/210',
            '150/200',
            '150/210',
            '150/220',
            '160/200',
            '160/210',
            '160/220',
            '180/220',
            '200/200',
            '200/220'
          ].map((size) => (
            <Typography key={size} variant="body1" sx={{ color: 'text.secondary' }}>
              {size}
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Благодарение на този богат избор можете лесно да намерите подходящ плик за бебешка завивка
          или плик за детско одеяло, дори когато размерът е по-нестандартен.
        </Typography>

        {/* H2: Какво представлява памучният сатен? */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Какво представлява памучният сатен?
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Памучният сатен е 100% памучен плат, който се изработва чрез специален начин на тъкане.
          Тази технология придава на материята по-гладка повърхност и лек естествен блясък.
        </Typography>
        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Основни предимства на памучния сатен
        </Typography>
        <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0 }}>
          <li>&#10004; 100% естествен памук</li>
          <li>&#10004; гладка и мека материя</li>
          <li>&#10004; приятен допир до кожата</li>
          <li>&#10004; добра дишаемост</li>
          <li>&#10004; комфорт по време на сън</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Пликовете за детски завивки от памучен сатен са отличен избор за родители, които търсят
          по-фино и приятно на допир детско спално бельо.
        </Typography>

        {/* H2: Предимства на нашите пликове за детски завивки от памучен сатен */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Предимства на нашите пликове за детски завивки от памучен сатен
        </Typography>
        <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0 }}>
          <li>&#10004; изработени от 100% памучен сатен</li>
          <li>&#10004; гладка и приятна на допир материя</li>
          <li>&#10004; голям избор от размери</li>
          <li>&#10004; подходящи за бебешки и детски завивки</li>
          <li>&#10004; дишащ и комфортен плат</li>
          <li>&#10004; платове със сертификат OEKO-TEX Standard 100</li>
          <li>&#10004; произведени в България</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Нашите детски пликове от памучен сатен са практично решение за родители, които търсят
          качествено и удобно детско спално бельо.
        </Typography>

        {/* H2: Популярни размери пликове за детски завивки от памучен сатен */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Популярни размери пликове за детски завивки от памучен сатен
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Сред най-търсените размери са:
        </Typography>
        <Box sx={{ mb: 4, pl: 2 }}>
          {[
            'плик за детска завивка 140/200 (140х200) см',
            'плик за детска завивка 150/210 (150х210) см',
            'плик за детска завивка 160/220 (160х220) см',
            'плик за бебешка завивка 105/140 (105х140) см'
          ].map((item) => (
            <Typography key={item} variant="body1" sx={{ color: 'text.secondary' }}>
              {item}
            </Typography>
          ))}
        </Box>

        {/* H2: Срок за изработка */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Срок за изработка
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Всички пликове се изработват индивидуално след направена поръчка, според избрания размер.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Срокът за изработка е между 3 и 10 работни дни, като в повечето случаи поръчките са готови
          в рамките на 4–7 работни дни.
        </Typography>
      </Collapse>
      <Button
        onClick={() => setExpanded(!expanded)}
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          mb: 3,
          '&:hover': { backgroundColor: 'rgba(212, 175, 55, 0.08)' }
        }}>
        {expanded ? 'Скрий' : 'Прочетете повече'}
      </Button>

      {/* H2: ЧЗВ */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 3 }}>
        Често задавани въпроси за пликове за детски завивки от памучен сатен
      </Typography>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Как да избера правилния размер плик за детска завивка?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            За да изберете подходящ плик за детска завивка, измерете ширината и дължината на
            завивката и изберете плик със същия или много близък размер.
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            В нашия магазин можете да намерите детски пликове за завивки в много различни размери,
            което позволява лесно да намерите подходящия вариант.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящ ли е памучният сатен за детско спално бельо?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Памучният сатен е 100% памучен плат, който е мек, дишащ и приятен на допир. Това го
            прави много подходящ за детско спално бельо и пликове за завивки.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Свива ли се пликът за детска завивка от памучен сатен след пране?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Както всички изделия от 100% памук, и пликовете от памучен сатен могат да имат
            естествена свиваемост около 4–5% след първите пранета. Това е нормално свойство на
            памучните материи.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящи ли са пликовете за различни размери детски завивки?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Благодарение на богатия избор от размери можете лесно да намерите подходящ плик за
            бебешка или детска завивка.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Къде се изработват пликовете за детски завивки?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Всички пликове се изработват в България, специално за всяка поръчка и според избрания
            размер.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
